const tagFilters = () => {
	//  found this here https://www.w3docs.com/snippets/javascript/how-to-detect-a-click-outside-an-element.html

	const tagList = $('.tagList');
	const filterDocSwitch = (e) => {
		const box = $('.tagBox')[0];
		const label = $('.tagLabel')[0];
		let target = e.target;
		do {
			if (target == box || target == label) {
				// This is a click inside 'filter-box'.
				// Toggle the 'Tag list' and return.
				tagList.toggle();
				return;
			}
			// Go up the DOM
			target = target.parentNode;
		} while (target);

		// This is a click outside.
		tagList.hide();
		tagList.attr('aria-expanded', false);
	};

	$(document).ready(function () {
		$(() => {
			// listeners for tags filters
			$(document).on('click focus', filterDocSwitch);
			tagList.hide();
			$('.tagLabel').on('focus', function () {
				tagList.show();
				tagList.attr('aria-expanded', true);
			});
		});
	});
	const tagListItems = document.querySelectorAll('.tagListA');

	// Get the last element in the NodeList
	const lastItem = tagListItems[tagListItems.length - 1];

	// Add a focusout event listener to the last item
	lastItem.addEventListener('focusout', function (event) {
		// Check if the focus is moving outside of the list (not to another '.tagListA' item)
		const nextElement = event.relatedTarget;

		if (!nextElement || !nextElement.classList.contains('tagListA')) {
			tagList.hide();
			tagList.attr('aria-expanded', false);
		}
	});

	document.addEventListener('keydown', function (e) {
		if (
			(e.key === 'Escape' && e.target.classList.contains('tagLabel')) ||
			(e.key === 'Escape' && e.target.classList.contains('tagListA'))
		) {
			tagList.hide();
			tagList.attr('aria-expanded', false);
		}
	});
};

export default tagFilters;
